<style lang="css" scope>
  .home-cupItem {
    display: inline-block;
    width: 33.33%;
    vertical-align: top;
  }
  .home-cups dl dd {
    padding: 0;
    margin: 0;
  }
  .home-cups .text-tip{
    padding: 0.1rem;
  }
  .home-cups .text-tip .cl-red {
    font-size : 0.3rem
  }
</style>
<template>
  <div class="home-cups">
    <div class="home-cupItem" v-for="item in matchList" :key="item.id">
      <router-link :to="`/winners/${item.id}`" class="hd-dk__link cl-white">
        <dl>
          <dt>{{ item.cupName }}</dt>
           <!--<dd>获奖名单</dd>-->
          <dd>{{ item.preRes | time2text('M月D日h点') }}</dd>
          <dd>公布</dd>
          <!--<<dd>{{ leftFor(item.preRes + 1000 * 60 * 60 * 24) }}</dd>-->
        </dl>
      </router-link>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'home-cups',
    data() {
      return {
        list: [],
        userMap: {}
      }
    },
    methods:{
      goLink(id){
        if(this.isBefore(this.beginTime)){
          //console.log('未开始')
          
        } else {
          this.$router.push({ path: '/winners/', query: { cId: id }})
          
        }
      }
    },
    computed: {
      ...mapGetters('config', ['matchList', 'cupOf', 'beginTime', 'endTime']),
      ...mapGetters('timer', ['isBefore', 'isAfter', 'leftFor'])
    }
  }
</script>
